import {
  Box,
  Step,
  stepIconClasses,
  StepLabel,
  stepLabelClasses,
  Stepper,
  Typography
} from "@mui/material";
import useCreateProject from "../hooks/useCreateProject";

const FlowStepper = () => {
  const { currentStep, flowWiseSteps } = useCreateProject();

  return (
    <Box
      sx={{
        alignItems: "flex-end",
        py: 0,
        px: 2
      }}
    >
      <Stepper
        activeStep={currentStep}
        sx={{
          // maxWidth: flowWiseSteps?.length === 2 ? 480 : 960,
          maxWidth: 600,
          mx: "auto"
        }}
      >
        {flowWiseSteps
          .filter((_) => !_.hidden)
          .map((_) => {
            const stepProps: { completed?: boolean } = {};
            return (
              <Step
                key={_.label}
                {...stepProps}
                active={currentStep === _.int}
                completed={currentStep > _.int}
                sx={{
                  [`& .${stepIconClasses.root}.${stepIconClasses.completed}`]: {
                    color: (theme) => theme.palette.success.main
                  },
                  [`& .${stepIconClasses.root}:not(.${stepIconClasses.completed}):not(.${stepIconClasses.active})`]:
                    {
                      color: (theme) => theme.palette.info.selected,
                      [`& .${stepIconClasses.text}`]: {
                        fill: (theme) => theme.palette.text.primary
                      }
                    },
                  [`& .${stepLabelClasses.label}`]: {
                    color: "text.secondary"
                  }
                }}
              >
                <StepLabel>
                  <Typography
                    variant="subtitle2"
                    color={"text.secondary"}
                    fontWeight={700}
                  >
                    {_.label}
                  </Typography>
                </StepLabel>
              </Step>
            );
          })}
      </Stepper>
    </Box>
  );
};

export default FlowStepper;
